<template>
  <section>
    <v-snackbar v-model="error">
      {{ errorMessage }}
      <v-btn dark color="pink" text @click="error = false"> Close </v-btn>
    </v-snackbar>

    <v-container>
      <v-row>
        <v-col cols="12" md="12"
          ><v-img
            class="white--text align-end rounded grey lighten-2"
            :src="loadData.attachment"
            :lazy-src="loadData.attachment"
            @click="overlay = !overlay"
            v-ripple
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
        <v-col cols="12" md="12">
          <h2 class="heading">{{ loadData.title }}</h2>
          <div class="my-4 overline">
            {{ loadData.created_at }} oleh {{ loadData.user_id }}
          </div>

          <div class="my-4" v-html="loadData.article"></div>
        </v-col>
      </v-row>

      <v-divider />
      <div class="sharenow">
        <h3 class="heading my-4 d-inline-block mr-3">Bagikan</h3>
        <ShareNetwork
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :style="{ backgroundColor: network.color }"
          :url="sharing.url + network.utm"
          :title="sharing.title"
          :description="sharing.description"
          :quote="sharing.quote"
          :hashtags="sharing.hashtags"
          :twitterUser="sharing.twitterUser"
        >
          <i :class="network.icon"></i>
          <span>{{ network.name }}</span>
        </ShareNetwork>
      </div>
      <v-divider />
    </v-container>
  </section>
</template>

<script>
import Axios from 'axios';
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueSocialSharing from 'vue-social-sharing';

Vue.use(VueSocialSharing);

// use lodash
Vue.use(VueLodash, { name: 'custom', lodash: lodash });

export default {
  name: 'ArticleDetail',
  data() {
    return {
      overlay: false,
      id: this.$route.params.id,
      loading: true,
      loadData: [],
      error: false,
      errorMessage: null,
      categoryName: '',
      facultyName: '',
      sharing: {
        url: window.location.href,
        title: '',
        description: null,
        quote: 'Semua kebutuhan event kampus',
        hashtags: 'eventversity',
        twitterUser: 'eventversity.id',
      },
      networks: [
        {
          network: 'whatsapp',
          name: 'Whatsapp',
          icon: 'fab fah fa-lg fa-whatsapp',
          color: '#25d366',
          utm:
            '?utm_source=whatsapp&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'facebook',
          name: 'Facebook',
          icon: 'fab fah fa-lg fa-facebook-f',
          color: '#1877f2',
          utm:
            '?utm_source=facebook&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'line',
          name: 'Line',
          icon: 'fab fah fa-lg fa-line',
          color: '#00c300',
          utm:
            '?utm_source=line&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'twitter',
          name: 'Twitter',
          icon: 'fab fah fa-lg fa-twitter',
          color: '#1da1f2',
          utm:
            '?utm_source=twitter&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'linkedin',
          name: 'LinkedIn',
          icon: 'fab fah fa-lg fa-linkedin',
          color: '#007bb5',
          utm:
            '?utm_source=linkedin&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
      ],
    };
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'articles/' + this.id)
      .then((response) => {
        this.loadData = response.data.data;
        console.log(this.loadData);
        this.sharing.title = this.loadData.title;
        this.sharing.description = this.removeTags(
          this.loadData.meta_description,
        );
      })
      .catch((error) => {
        console.log(error);
        this.error = true;
        this.errorMessage = error;
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    removeTags(str) {
      if (str === null || str === '') return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, '');
    },
  },
  computed: {},
  metaInfo() {
    return {
      title: this.loadData.title,
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
    };
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 5px;
  border: 1px solid #dbdbdb;
}
.close-box {
  position: absolute;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  padding: 8px;
}

.sharenow {
  overflow: auto;
  white-space: nowrap;
  margin-top: 8px;
  margin-bottom: 12px;
}

a[class*='share-network'] {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  display: inline-block;
  margin-right: 8px;
}
</style>
